import React from 'react';

const SvgDropdown = (props) => (
    <svg width={9} height={5} {...props} viewBox="0 0 9 5">
        <path d="M7.557.5L4.5 2.973 1.443.5.5 1.263l4 3.237 4-3.237z" fill={props.color || '#FFF'} fillRule="evenodd" />
    </svg>
);

export default SvgDropdown;
